var map = {
	"./child.png": 4068,
	"./covid.png": 8456,
	"./dental.png": 4857,
	"./docred.png": 6476,
	"./docyellow.png": 1435,
	"./eye.svg": 6535,
	"./hbig.png": 6617,
	"./heart.png": 1141,
	"./herodoc.png": 9051,
	"./hmdevice.jpg": 5053,
	"./hsmall.png": 6842,
	"./hsmall2.png": 8138,
	"./nutri.png": 6058,
	"./soul.png": 9002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1831;